import { render, staticRenderFns } from "./lsDistToRegList.vue?vue&type=template&id=70977c91&scoped=true&"
import script from "./lsDistToRegList.vue?vue&type=script&lang=js&"
export * from "./lsDistToRegList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70977c91",
  null
  
)

export default component.exports